import React from 'react';

const Under_maintain =() => {
  return (
    <>
        <div className='under_maintainance_img'>
        <img src='images/under maintenance.svg' alt=" " />
        </div>
    </>
  )
};

export default Under_maintain;